// Copyright (c) Bentley Systems
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "./store";

type formOpenState = {
  isOpen: boolean;
}

const initialState: formOpenState = {
  isOpen: false,
};

export const formOpenSlice = createSlice({
  name: "formOpen",
  initialState,
  reducers: {
    setformOpen: (state, action: PayloadAction<formOpenState>) => {
      state.isOpen = action.payload.isOpen;
    },
  },
});

export const { setformOpen } = formOpenSlice.actions;

export const selectFormOpen = (state: RootState) => state.formOpen;

export default formOpenSlice.reducer;
